import React from "react";
import { MdOutlineStickyNote2 } from "react-icons/md";
import { fulfilmentNote, productNote } from "./lineNoteText";

/**
 * A line's notes, to read: the shipper's product note (an instruction for
 * picking or delivering it) and, unless `fulfilment` is false, the
 * fulfilment note written when it was last fulfilled. Nothing when there's
 * neither.
 */
const LineNotes = ({ item, fulfilment = true, className = "" }) => {
  const product = productNote(item);
  const done = fulfilment ? fulfilmentNote(item) : "";
  if (!product && !done) return null;
  return (
    <span className={`grid basis-full gap-[2px] ${className}`}>
      {product && (
        <span className="flex items-start gap-[4px] rounded-[4px] bg-state-warning-bg px-[6px] py-[2px] text-[12px] text-state-warning-text lg:text-[11.5px]">
          <MdOutlineStickyNote2
            aria-hidden="true"
            className="mt-[2px] h-[11px] w-[11px] shrink-0"
          />
          <span>
            <b>Product note:</b> {product}
          </span>
        </span>
      )}
      {done && (
        <span className="px-[6px] text-[12px] text-ui-text-muted lg:text-[11.5px]">
          <b>Fulfilment note:</b> {done}
        </span>
      )}
    </span>
  );
};

export default LineNotes;
